import React from 'react'
import SearchIcon from "@material-ui/icons/Search";
import "../subscribe/Subscribe.css";


function Subscribe() {
    return (
        <div className="holder___">
            <div>
                <h2 className="sub_heading">Don't Miss Out On Our Daily Fashion Trends!</h2>
            </div>
            <div className="text__input__holder">
            <input type="text" className="header_searchInput" />
            {/* <SearchIcon className="header_searchIcon"/> */}
            <p className="sub_btn">Subscribe</p>
            </div>           
            

        </div>
    )
}

export default Subscribe

